//------------------------------------------------------------
// File:      DataLookup.ts
// Author:    Tony Henderson
// Generator: ElevenFiftyNine Automated Tool Chain  
// Project:   https://github.com/BinaryBlox-Schedule-API
//------------------------------------------------------------


// Entity Side Effects: DataLookup Entity Effects  
import { ThunkAction, Action  } from '@reduxjs/toolkit'
import { entityActions } from '../slices/DataLookup.slice'
import { ApiManager } from '../../api-manager';

const DEFAULT_TARGET: string = '/'; 

/**
* Generated import statments DataLookup for tag entities 
*/
import { 
    CountyRequest, 
    DistrictRequest, 
    RegionRequest, 
} from '../../model/index';




/**
* apiDataLookupGetAllPOST
* @param apiFactory PostApiCountyGetAllApiFactory
* @param body CountyRequest
* @param history any  (optional) 
* @param target string (optional)
*/
export const fetchGetAll_County_GetAll = <R>(apiFactory: Function, body: CountyRequest, history?: any, target?: string, debug?: boolean, mock?: any): ThunkAction<any, R, null, Action<string>> => async (dispatch: (request: any, history?: any, target?: string) => any) => {

      if(!apiFactory){ 
            console.log(`API Factory is undefined or null :  CountyApiFactory `);
            return; 
      };

      const apiCall: string =  'apiCountyGetAllPost';    
      const entityApi =   apiFactory(ApiManager.getInstance().getConfiguration()); 
      console.log(`API: ${apiCall}`); 

      let payload = body; 
      if(debug){console.log(`PAYLOAD: ${JSON.stringify(payload, undefined, '\t')}`)};

      dispatch(entityActions.getAll_County_GetAll_Data())

      // Mock implementation to be tested 
      if(mock){
            console.log(`MOCK API SUCCESS: ${apiCall}`);       
            return await dispatch(entityActions.getAll_County_GetAll_Data_Success(mock))
      }

      return await entityApi.apiCountyGetAllPost("1.0.0", payload).then((response: any) => {        
            console.log(`API SUCCESS: ${apiCall}`);      
            const result = response; 
            return dispatch(entityActions.getAll_County_GetAll_Data_Success(result.data))
            },
            (error: { data: any; }) => {
                  console.log(`API FAIL: ${apiCall}`);
                  return dispatch(entityActions.getAll_County_GetAll_Data_Fault(error.data))
      }); 
}

/**
* apiDataLookupGetAllPOST
* @param apiFactory PostApiDistrictGetAllApiFactory
* @param body DistrictRequest
* @param history any  (optional) 
* @param target string (optional)
*/
export const fetchGetAll_District_GetAll = <R>(apiFactory: Function, body: DistrictRequest, history?: any, target?: string, debug?: boolean, mock?: any): ThunkAction<any, R, null, Action<string>> => async (dispatch: (request: any, history?: any, target?: string) => any) => {

      if(!apiFactory){ 
            console.log(`API Factory is undefined or null :  DistrictApiFactory `);
            return; 
      };

      const apiCall: string =  'apiDistrictGetAllPost';    
      const entityApi =   apiFactory(ApiManager.getInstance().getConfiguration()); 
      console.log(`API: ${apiCall}`); 

      let payload = body; 
      if(debug){console.log(`PAYLOAD: ${JSON.stringify(payload, undefined, '\t')}`)};

      dispatch(entityActions.getAll_District_GetAll_Data())

      // Mock implementation to be tested 
      if(mock){
            console.log(`MOCK API SUCCESS: ${apiCall}`);       
            return await dispatch(entityActions.getAll_District_GetAll_Data_Success(mock))
      }

      return await entityApi.apiDistrictGetAllPost("1.0.0", payload).then((response: any) => {        
            console.log(`API SUCCESS: ${apiCall}`);      
            const result = response; 
            return dispatch(entityActions.getAll_District_GetAll_Data_Success(result.data))
            },
            (error: { data: any; }) => {
                  console.log(`API FAIL: ${apiCall}`);
                  return dispatch(entityActions.getAll_District_GetAll_Data_Fault(error.data))
      }); 
}

/**
* apiDataLookupGetAllPOST
* @param apiFactory PostApiRegionGetAllApiFactory
* @param body RegionRequest
* @param history any  (optional) 
* @param target string (optional)
*/
export const fetchGetAll_Region_GetAll = <R>(apiFactory: Function, body: RegionRequest, history?: any, target?: string, debug?: boolean, mock?: any): ThunkAction<any, R, null, Action<string>> => async (dispatch: (request: any, history?: any, target?: string) => any) => {

      if(!apiFactory){ 
            console.log(`API Factory is undefined or null :  RegionApiFactory `);
            return; 
      };

      const apiCall: string =  'apiRegionGetAllPost';    
      const entityApi =   apiFactory(ApiManager.getInstance().getConfiguration()); 
      console.log(`API: ${apiCall}`); 

      let payload = body; 
      if(debug){console.log(`PAYLOAD: ${JSON.stringify(payload, undefined, '\t')}`)};

      dispatch(entityActions.getAll_Region_GetAll_Data())

      // Mock implementation to be tested 
      if(mock){
            console.log(`MOCK API SUCCESS: ${apiCall}`);       
            return await dispatch(entityActions.getAll_Region_GetAll_Data_Success(mock))
      }

      return await entityApi.apiRegionGetAllPost("1.0.0", payload).then((response: any) => {        
            console.log(`API SUCCESS: ${apiCall}`);      
            const result = response; 
            return dispatch(entityActions.getAll_Region_GetAll_Data_Success(result.data))
            },
            (error: { data: any; }) => {
                  console.log(`API FAIL: ${apiCall}`);
                  return dispatch(entityActions.getAll_Region_GetAll_Data_Fault(error.data))
      }); 
}

/**
* { name|upperCamelCase }} entityRequests
*/
export const entityRequests = { 
      fetchGetAll_County_GetAll,                                
      fetchGetAll_District_GetAll,                                
      fetchGetAll_Region_GetAll,                                
};    
   